<template>
  <div class="form-group esma_form_group">
    <label v-if="showLabel" v-bind:for="fieldID"
    :class="labelClass"
    >{{fieldLabel}} <span v-if="isRequired" class="is_required" aria-hidden="true">＊</span></label>
    <div :class="fieldClass"  style="padding:1px 0px 1px 7px;">
      <select  class="form-control select-box"
      :style="filedStyle"
      :disabled="isDisabled"
      v-on:change="updateValue($event.target.value)"
      v-bind:id="fieldID"
      v-bind:name="fieldID"
      v-bind:value="fieldValue"
      v-on:click="onClick"
        >
        <option v-for="o in fieldOptions" :selected="o==fieldValue" v-bind:data="o" v-bind:key="o" val=".">{{specialLabels(o)}}</option>
      </select>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { bus } from "@/libs/bus";
import debug from "debug";
import _ from "lodash";
import constants from '../../rules/constants';
var debug_select = debug("__esma:select-box");
export default {
  data() {
    return {
      local_options: [],
      selection_rules: false,
      listen_for: false,
      forced_options: null,
      value_updated:false,
      cache_for_disable_and_clean_if_value:false,
      local_disabled:false,
      label_class:"col-xs-4 control-label esma_form_label",
      local_refresh_sequecnce: 1,
      show_as_error:false,
      last_emit_value:false,
      last_emit_time:0,
      disabled_is_required:false,
      external_disabled:false
    };
  },
    computed: {
    externalDisabled:{
      get(){
        return this.external_disabled;
      },
      set(v){
        this.external_disabled = v;
      }
    },
      disabledIsRequired:{
        get(){
          return this.disabled_is_required;
        },
        set(v){
          var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
          if(typeof local_val == "undefined"){
            local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
          }
          this.disabled_is_required = v;
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
          this.localRefreshSequecnce++;
        }
      },
      isRequired(){
        return this.localRefreshSequecnce > 0 && this.disabledIsRequired == false && (this.$props.data.error_if_blank || false);
      },
      showAsError:{
        get(){
          return this.show_as_error;
        },
        set(v){
          this.show_as_error = v;
        }
      },
      localRefreshSequecnce:{
      get(){
        return this.local_refresh_sequecnce;
      },
      set(v){
        this.local_refresh_sequecnce = v;
      }
      },
      labelClass(){
        var complement = (this.showAsError == true)? " esma_error_field":"";
        if(typeof this.$props.data.label_class != "undefined"){
          return this.$props.data.label_class + complement
        }else{
          return this.label_class + complement
        }
      },
      localDisabled:{
        get(){
          return this.local_disabled;
        },
        set(v){
          this.local_disabled = v;
        }
      },
      filedStyle() {
        var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || ";color:black;";
        return (this.$props.data.field_style || "") + store_style;
      },
      stateCurrentRow(){
        if(typeof this.$props.data.state_current_row != "undefined"){
          return this.$props.data.state_current_row;
        }else{
          return "current_row";
        }
      },
      stateCurrentEditing(){
        if(typeof this.$props.data.state_current_editing != "undefined"){
          return this.$props.data.state_current_editing;
        }else{
          return "current_editing";
        }
      },
      stateIsEditingNew(){
        if(typeof this.$props.data.state_is_editing_new != "undefined"){
          return this.$props.data.state_is_editing_new;
        }else{
          return "is_editing_new";
        }
      },
      fieldTableName() {
        return this.$props.data.table_name;
      },
      fieldOptions() {
        var base_options = this.$props.data.options;



        if(typeof this.$props.data.from_local_storage != "undefiend" && this.$props.data.from_local_storage && this.$props.data.from_local_storage.length > 0){
          var ls = Vue.localStorage.get(this.$props.data.from_local_storage);
          var default_val = Vue.localStorage.get(this.$props.data.default_from_local_storage);
          if(default_val == constants.COMPANY.ALL){
            default_val = "";
          }
          if(ls && ls.length > 0){
            base_options = [];
            JSON.parse(ls).forEach(v=>{
              base_options.push(v.value);
              if(default_val && default_val.length > 0 && v.value == default_val && this.value_updated == false){
                setTimeout(()=>{
                    if(this.fieldValue == ""){ // FIXME: , should be only for new
                        this.updateValue("");
                        this.$store.state[this.stateCurrentRow][this.fieldID] = default_val;
                        this.updateValue(default_val);
                        this.refreshOptions();
                    }
                },100);
              }
            })
          }
        }
        else if(typeof this.$props.data.default_value != "undefiend" && this.$props.data.default_value && this.$props.data.default_value.length > 0){
          if(this.fieldValue == ""){
              this.updateValue("");
              this.$store.state[this.stateCurrentRow][this.fieldID] = this.$props.data.default_value;
              this.updateValue(this.$props.data.default_value);
              this.refreshOptions();
          }
        }


        debug_select("base_options", base_options);
        debug_select("select-box this.$props.data",this.$props.data)

        if (this.forced_options != null && this.isDisabled == false) {
          debug_select("field Options using forced options", this.forced_options);
          base_options = this.forced_options;
        } else {
          debug_select("field Options using normal options", this.forced_options, base_options);
        }
        this.local_options = [];
        base_options.forEach(d => {
          this.local_options.push(d);
        });
        if (this.local_options.indexOf(this.fieldValue) < 0) {
        debug_select("field Options step 1",this.fieldValue);
          if (this.forced_options == null) {
          debug_select("field Options step 2",this.fieldValue);
            this.local_options.unshift(this.fieldValue);
          } else {
          debug_select("field Options step 3", this.fieldID);
            this.$store.state[this.stateCurrentRow][this.fieldID] = "";
          }
        }
        debug_select("field Options using FINAL options", {forced_options:this.forced_options,local_options:this.local_options});
        // if(this.local_options.indexOf("") < 0 && this.fieldValue != "" && this.fieldValue != null && this.$props.data.no_blank != true){
        //   this.local_options.unshift("");
        // }
        _.remove(this.local_options,(d)=> {return d == "" || d == null})
        return this.local_options;
      },
      fieldLabel() {
        return this.$props.data.label;
      },
      fieldValue() {
        var val = this.$store.state[this.stateCurrentRow][this.fieldID];
        if (this.local_options.indexOf(val) < 0) {
          if (this.forced_options == null) {
            this.local_options.unshift(val);
          } else {
            this.$store.state[this.stateCurrentRow][this.fieldID] = "";
          }
        }
        if (typeof this.$props.data.on_set_value == "function") {
          var now = (new Date()).getTime();
          // var last = (new Date(this.last_emit_time)).getTime();
          if(this.last_emit_value != this.$store.state[this.stateCurrentRow][this.fieldID] || (now - this.last_emit_time) > 500  ){
            this.last_emit_time = now;
            this.last_emit_value = this.$store.state[this.stateCurrentRow][this.fieldID]
            this.$props.data.on_set_value(this.$store.state[this.stateCurrentRow][this.fieldID])
          }
        }
        return (this.localRefreshSequecnce > 0) ?this.$store.state[this.stateCurrentRow][this.fieldID]:"";
      },
      fieldID() {
        return this.$props.data.id;
      },
      fieldClass() {
        if(typeof this.$props.data.field_class != "undefined"){
          return this.$props.data.field_class;
        }else if (this.getOption("hide_label", false) == true) {
          return "col-xs-12";
        } else {
          return "col-xs-8";
        }
      },
      showLabel() {
        if (this.getOption("hide_label", false) == true) {
          return false;
        } else {
          return true;
        }
      },
      isDisabled() {
        var ret = null;
        if (this.$store.state[this.stateIsEditingNew] == true) {
          ret = this.localDisabled || this.externalDisabled ||this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"; //TODO, can also has another field to force it.
        } else {
          ret = this.localDisabled || this.externalDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
        }
        if (ret == false) {
          this.checkToApplySelectionRules(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        return ret;
      }
  },
  methods: {
    specialLabels(v){
        return v;
    },
    onClick() {
      // debug_select("onClick")/
    },
    updateValue(d) {
      debug_select("updateValue",d)
      this.value_updated = true;


      if (typeof this.$props.data.global_emit != "undefined") {
        bus.$emit(this.$props.data.global_emit, d);
      }
      if (typeof this.$props.data.on_set_value == "function") {
        this.$props.data.on_set_value(d)
      }
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
      this.checkToApplySelectionRules(d);
      if(this.$props.data.emit_input == true){
        this.$emit("on_update",{field:this.fieldID,val:d});
      }
    },
    getOption(name, def) {
      //debug_select("getOption",name,def)
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    },
    onReceiveEvents(e, data) {
      // debug_select("onReceiveEvents my id ",this.$props.data.id,"Event",e,"Data",data)
      if (e.mode == "select_only") {
        debug_select("RECEIVING '", this.$props.data.id, "' set only '", data.allow, "' as requested by '", e.name,"'");
        this.forced_options = data.allow;
        if(data.allow && data.allow.length == 1 && data.allow[0] ==""){
          this.$store.state[this.stateCurrentRow][this.$props.data.id] = "";
          this.$store.state[this.stateCurrentEditing][this.$props.data.id] = "";
        }

      }else if (e.mode == "select_and_set_only") {
        debug_select("RECEIVING '", this.fieldID, "' set only '", data.allow, "' as requested by '", e.name,"'");
        this.forced_options = data.allow;
        if(data.disable === true){
          this.localDisabled = true;
        }else if(data.disable === false){
          this.localDisabled = false;
        }
        if(data.allow && data.allow.length == 1 && data.select == true){
          this.$store.state[this.stateCurrentRow][this.fieldID] = "";
          this.$store.state[this.stateCurrentEditing][this.fieldID] = "";
          this.localRefreshSequecnce ++;
          setTimeout(() => {
            this.$store.state[this.stateCurrentRow][this.fieldID] = data.allow[0];
            this.$store.state[this.stateCurrentEditing][this.fieldID] = data.allow[0];
            this.localRefreshSequecnce ++;
          }, 200);
        }
      }else if(e.mode == "disable_if_value"){
        if(e.disable_if_value == data.val){
          this.localDisabled = false;
        }else{
          this.localDisabled = true;
        }
      }else if(e.mode == "disable_and_clean_if_value"){
        if(e.disable_if_value == data.val){
          if(this.localDisabled != false){
            this.$store.state[this.stateCurrentRow][this.fieldID]= this.cache_for_disable_and_clean_if_value||"";
            this.$store.state[this.stateCurrentEditing][this.fieldID]= this.cache_for_disable_and_clean_if_value||"";
          }
          this.localDisabled = false;
        }else{
          if(this.localDisabled != true){
            this.cache_for_disable_and_clean_if_value = this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID]||this.$props.data.default||"";
          }
          this.localDisabled = true;
          this.$store.state[this.stateCurrentRow][this.fieldID]= this.$props.data.default||"";
          this.$store.state[this.stateCurrentEditing][this.fieldID]= this.$props.data.default||"";
        }
      }
    },
    checkToApplySelectionRules(selected) {
      if (this.selection_rules != false) {
        debug_select("checkToApplySelectionRules for ",selected)
        this.selection_rules.forEach(rule => {
          if (rule.action == "select_only" && rule.mode == "on_select") {
            var allow = rule.options[selected] || null;
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, {allow,from: this.$props.data.id});
            bus.$emit(rule.event_name, { allow, from: this.$props.data.id });
          } else if (rule.action == "enable_if_match_or_empty" && rule.mode == "on_select") {
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, {selected,id: this.fieldID});
            bus.$emit(rule.event_name, { selected, id: this.fieldID });
          }
        });
      }
    },
    refreshOptions(){
      var temp = _.clone(this.local_options)
      this.local_options = [];
      temp.forEach(e=>{
        this.local_options.push(e)
      })
    }
  },
  mounted() {

    this.$props.data.ref_field = this;
    // debug_select("mounted")
    if (typeof this.$props.data.selection_rules != "undefined" && this.$props.data.selection_rules.length > 0) {
      // debug_select("set selection_rules")
      this.selection_rules = this.$props.data.selection_rules;
    }
    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(e => {
        // debug_select("mounted set listen_for ",e)
        bus.$off(e.name).$on(e.name, data => {
          this.onReceiveEvents(e, data);
        });
      });
    }
    if(typeof this.$props.data.listen_for_value != "undefined"){
      var bus_name = this.$props.data.listen_for_value;
      bus.$off(bus_name).$on(bus_name,(new_value)=>{
        this.updateValue(new_value); // It set the real value to edit
        this.$store.state[this.stateCurrentRow][this.fieldID] = new_value; // It set the visual value
        // this.refreshOptions();  // It force to refresh the list. And update the value
        this.localRefreshSequecnce++; // it will force the value to trigger.
      })
    }
    this.$props.data.on_field_messages = (vm,msg,cb) =>{
      if(msg && msg.msg_type == "error"){
        if(msg.show_as_error_mode == false && this.showAsError == false){
          return cb(false);
        }
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        if(msg.show_as_error_mode && msg.only_if_enabled == true && this.isDisabled == true){
          this.showAsError = false;
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
          this.localRefreshSequecnce++;
          return cb(false);
        }
        this.showAsError = msg.show_as_error_mode || false;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
        return cb(true);
      }
    }
    if(this.$props.data.page_controller){
      this.$props.data.page_controller_msg = (options) =>{
        switch (options.cmd) {
          case "enable":
            this.localDisabled = false;
            break;
          case "disable":
            this.localDisabled = true;
            break;
          default:
            break;
        }
      }
    }
  },
  beforeDestroy(){
    if(typeof this.$props.data.listen_for_value != "undefined"){
      var bus_name = this.$props.data.listen_for_value;
      bus.$off(bus_name)
    }
  },

  props: ["data", "value", "option", "read"]
};
</script>
<style scoped>
.esma_error_field {
  color:red;
}
.is_required{
  color:red;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: #cccccc;

  padding: 0px 6px 0px 6px;
}
.form-control {
  color: black;
  height: 24px;

  padding: 0px 6px 0px 6px;
}
.form-control::selection {
  color: white;
  background: #575757;
}
::-webkit-input-placeholder { /* Edge */
  color: red;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: red;
}

::placeholder {
  color: red;
}
</style>



// WEBPACK FOOTER //
// select-box.vue?08bc00ca